import React from "react";
import "./s.loading_overlay.css";

export const LoadingOverlay = () => (
    <div className="loading_overlay">
        <span className="loading_overlay__spinner" />
    </div>
);
